interface WPInstance {
  label: string;
  value: string;
}

export const availableWPInstances: WPInstance[] = [
  {
    label: 'Production',
    value: 'cms-prd.triadplatform.com',
  },
  {
    label: 'ProdCopy',
    value: 'cms-prd-copy.triadplatform.com',
  },
  {
    label: 'Staging',
    value: 'triadmsstage.wpengine.com',
  },
  {
    label: 'Uat',
    value: 'triadmsuat.wpengine.com',
  },
  {
    label: 'Local',
    value: 'triadms-wordpress.local',
  },
];
